module.exports = __webpack_public_path__ + "img/img-prod-descont-flag.fac79c3c.png";